import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, offerIncludes, offerRows } from '../data/matikka';
import { PRODUCT_IMAGE } from '../data/assets';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-240" data-mp="1mpd5s4kh617g">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-241" data-mp="1hqs5641b9fih">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-242" data-mp="u0xspnkwlsyr">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-243" data-mp="p0jwd2so07gk">
            Tutustu koko <em className="text-red-300" style={{
            hyphens: 'manual'
          }} data-id="element-244" data-mp="13y2g1qqhjuh5">MATIKKA VALMIS™</em> -pakettiin
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-245" data-mp="ywd4m9zcpesj">
            Koko lukuvuoden matematiikka valmiiksi suunniteltuna. Aloita 5 minuutissa.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-246" data-mp="2ac1t55s96lvg" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-247" data-mp="pjz47x579lzu">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-248" data-mp="zhvdskiho8vu">Koko paketti sisältää</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-249" data-mp="13jqebmslii8k">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-250" data-mp="6uiow3ouvozd">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-251" data-mp="6rwhq55vnbho">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-252" data-mp="funuc8ahodaw" />
                </span>
                <span data-id="element-253" data-mp="kldzplix0g5l">
                  <span className="block font-medium leading-snug" data-id="element-254" data-mp="kmp49nk6prxr">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-255" data-mp="3k7krgu7ghomy">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-256" data-mp="vfqtjs3t4ung">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-257" data-mp="qfutg3y8dnd6">Tutustumishinta <s className="ml-1 text-slate-900/50" data-id="element-258" data-mp="155tmjsaxi8ls">{PRICE_BEFORE}</s></p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-259" data-mp="106h0h9rvt5k9">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-260" data-mp="chelyasjnstz">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="7jmhkhapqe8w" />
            Kertamaksu. Ei tilausta.
          </p>

          <CtaButton label="Hanki koko paketti nyt" className="mt-8 w-full" data-id="element-262" data-mp="lf86ypkuz01u" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-263" data-mp="heo91jsgnsen">
            {offerIncludes.map(item => <li key={item} data-id="element-264" data-mp="1sv4pngfr4f33">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}